<template>
    <div class="fixed z-index-fixed bottom-0 left-0 w-screen">
        <div class="wrapper-menubar bg-white py-6 px-4">
            <div class="relative">
                <input type="text"
                    class="w-full border border-a-gray-c6c6c6 rounded-xl
                    bg-white placeholder-a-gray-c6c6c6 text-20 px-3 py-2.5 pr-36"
                    :class="{'pr-44': showImage}"
                    v-model="content"
                    placeholder="ความคิดเห็น">
                <div class="absolute right-2 top-2">
                    <div class="flex items-center">
                        <img class="h-5 w-auto mr-1" :src="showImage" alt="" @click="removeImage()" />
                        <img @click="clickSelectFile()" class="h-6 w-auto mr-1" src="@/assets/icon/ic-add-attact.png" alt=""/>
                        <div class="text-20 w-full bg-green-1 text-white rounded-full text-center py-1 px-2
                            flex items-center justify-center">
                            <div class="text-16" @click="clickCallapiAddcomment()">แสดงความคิดเห็น</div>
                        </div>
                        <input
                            v-if="resetFile"
                            class="w-0 h-0 hidden" type="file" ref="input-upload-img"
                            @input="onFileSelected($event)">
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
//mixin
import AuthStatusMixin from "@/mixin/AuthStatusMixin.js";
import LocaleMixin from "@/mixin/LocaleMixin.js";
import Util from "@/helper/Utility.js";

export default {
    name: "AddComment",
    props: {
        modalController: Object,
    },
    mixins: [AuthStatusMixin,LocaleMixin],
    data: function() {
        return {
            pageActive: this.$route.name,
            resetFile: true,
            selectedFileName: "",
            objUploadImg: null,
            content: "",
            isValid: false,
            errMessage: "",
            showImage: null,
        };
    },
    methods: {
        clickTab: function (path) {
            this.$router.push(path);
        },
        clickSelectFile: function() {
            this.$refs['input-upload-img'].click();
        },
        onFileSelected: async function(event) {
            let file = this.$refs['input-upload-img'].files[0];
            if (file && this.checkFileCondition(file)) {
                this.objUploadImg = event.srcElement.files[0];

                let fileReader = new FileReader();
                fileReader.readAsDataURL(file);
                fileReader.onload = (e) => {
                    this.showImage = e.target.result;
                };
            }
        },
        setFileName: function(fileName) {
            if (fileName.length > 20) {
                fileName = fileName.substr(0, 20) + '...';
            }
            this.selectedFileName = fileName;
        },
        removeImage: function () {
            this.$refs['input-upload-img'].value = null;
            this.showImage = null;
            this.objUploadImg = null;
        },
        checkFileCondition: function(file) {
            if (!Util.isFileTypeJpg(file.type) && !Util.isFileTypePng(file.type)) {
                this.alertModal
                        .clearModal()
                        .setMsg('file type not allow')
                        .show();
                return false;
            }

            if (file.size > this.fileSizeLimit) {
                this.alertModal
                        .clearModal()
                        .setMsg('file size too large')
                        .show();
                return false;
            }
            return true;
        },
        resetInputFile: function() {
            this.resetFile = false;
            this.$nextTick(() => {
                this.resetFile = true;
            });
        },
        clickCallapiAddcomment: function () {
            let dataSaveComment = {
                content: this.content,
                objUpload: this.objUploadImg,
            }
            this.validateInput()
            if(!this.isValid) {
                this.$emit("saveCommentSuccess", dataSaveComment);
            } else {
                this.modalController.alertModal
                    .clearModal()
                    .setMsg(this.errMessage)
                    .show();
            }
        },
        validateInput: function () {
            if (!this.content) {
                this.errMessage = "กรุณาระบุความคิดเห็น";
                this.isValid = true;
                return;
            }
            if (this.content.length < 10) {
                this.errMessage = "กรุณาระบุข้อความอย่างน้อย 10 ตัวอักษร";
                this.isValid = true;
                return;
            }
            this.isValid = false;
        }
    },
}
</script>
